import { ICloudReceiverModel, ReceiverParsedKeyType } from '@apps-common/types/portal/cloud-receiver'
import { create } from 'zustand'

export const DEFAULT_RECEIVERS_FILTER_STORE_PROPS: IReceiversFilterProps = {
  tab: 'gateways',
  serverId: '',
  companyId: '',
  queueSize: '',
  data: null
}

export interface IReceiversFilterProps {
  tab: ReceiverParsedKeyType
  serverId: string
  companyId: string
  queueSize: string
  data: ICloudReceiverModel | null
}

export interface IReceiversFilterState extends IReceiversFilterProps {
  setTab: (value: ReceiverParsedKeyType) => void
  setServerId: (value: string) => void
  setCompanyId: (value: string) => void
  setQueueSize: (value: string) => void
  setData: (value: ICloudReceiverModel | null) => void
  getFilteredByKeywords: () => string[]
  clear: () => void
}

export const useReceiversFilterStore = create<IReceiversFilterState>((set, get) => ({
  ...DEFAULT_RECEIVERS_FILTER_STORE_PROPS,
  setTab: (value) => set({ tab: value }),
  setServerId: (value) => set({ serverId: value }),
  setCompanyId: (value) => set({ companyId: value }),
  setQueueSize: (value) => set({ queueSize: value }),
  setData: (value) => set({ data: value }),
  getFilteredByKeywords: () => {
    const { tab, serverId, companyId, queueSize } = get()

    const keywords: string[] = []

    if (tab !== 'gateways') {
      keywords.push('Tab')
    }

    if (serverId && serverId.length > 0) {
      keywords.push('Server')
    }

    if (companyId && companyId.length > 0) {
      keywords.push('Company')
    }

    if (queueSize && queueSize.length > 0) {
      keywords.push('Queue')
    }

    return keywords
  },
  clear: () => {
    const { data } = get()

    set({
      tab: 'gateways',
      serverId: '',
      companyId: '',
      queueSize: '',
      data: data || null
    })
  }
}))
